export const logInfo = (message: string, info?: any) => {
  console.info(message, info);
};

export const logError = (error: any, errorInfo?: any) => {
  if (error.code && error.code >= 400 && error.code < 500) {
    logInfo(error, errorInfo);
  } else {
    console.error(error, errorInfo);
  }
};
